export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20spotlight%20rays%20piercing%20through%20a%20darkened%20theater%20space%2C%20dramatic%20smoke%20and%20haze%20texture%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20luxurious%20velvet%20curtain%20texture%20subtle%20in%20background%2C%20no%20people%2C%20abstract%20cinematic%20composition%2C%20elegant%20and%20mysterious%20mood%2C%20high-end%20theater%20aesthetic&width=1600&height=900&seq=hero-bg-cinema-01&orientation=landscape"
          alt="哈哈影院 - 影院级观影氛围"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/80 to-background-50/40 z-[1]"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent z-[1]"></div>

      {/* Content */}
      <div className="relative z-[2] w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tagline */}
            <p className="inline-flex items-center gap-2 text-accent-500 text-sm font-medium tracking-widest uppercase mb-4">
              <span className="w-6 h-px bg-accent-500/60"></span>
              高清 · 免费 · 不缓冲
            </p>

            {/* H1 */}
            <h1 className="text-foreground-950 font-heading text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4">
              哈哈影院
              <span className="block text-foreground-700 text-xl md:text-2xl lg:text-3xl font-normal mt-2">
                高清免费在线观影平台
              </span>
            </h1>

            {/* Slogan */}
            <p className="text-accent-500 font-heading text-lg md:text-xl mb-6">
              海量影视，即刻畅享，不卡顿不缓冲
            </p>

            {/* Intro */}
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              哈哈影院汇聚海量高清电影、热播电视剧、热门综艺与动漫番剧，为您打造极致流畅的在线观影体验。每日同步更新最新资源，全站高清画质、智能加速播放，无论热门大片还是经典老片，打开即看，不等待不卡顿，让每一次观影都成为一种享受。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <p className="text-accent-500 font-heading text-2xl md:text-3xl font-bold">10万+</p>
                <p className="text-foreground-500 text-xs mt-1">影视资源</p>
              </div>
              <div className="text-center">
                <p className="text-accent-500 font-heading text-2xl md:text-3xl font-bold">每日更新</p>
                <p className="text-foreground-500 text-xs mt-1">实时同步</p>
              </div>
              <div className="text-center">
                <p className="text-accent-500 font-heading text-2xl md:text-3xl font-bold">全端适配</p>
                <p className="text-foreground-500 text-xs mt-1">随时随地看</p>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors cursor-pointer text-sm"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#features"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-3 border border-foreground-300/40 hover:border-foreground-500 text-foreground-700 hover:text-foreground-900 font-medium rounded-lg transition-colors cursor-pointer text-sm"
              >
                了解平台优势
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {/* Right Visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-lg hidden md:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-2xl blur-3xl"></div>
              <div className="relative rounded-xl overflow-hidden border border-background-300/40">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20collage%20with%20dramatic%20lighting%2C%20golden%20and%20crimson%20color%20palette%2C%20vintage%20movie%20theater%20aesthetic%2C%20film%20strip%20texture%20overlay%2C%20classic%20cinema%20marquee%20lights%20feel%2C%20warm%20ambient%20glow%2C%20artistic%20composition%2C%20rich%20contrast%2C%20elegant%20dark%20background&width=600&height=800&seq=hero-poster-cinema-02&orientation=portrait"
                  alt="哈哈影院精选影视合集"
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Floating badge */}
              <div className="absolute -bottom-3 -right-3 bg-primary-500 text-background-50 px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap">
                <i className="ri-flashlight-fill mr-1"></i>极速播放
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}